import React from 'react';

import { Skeleton } from '@mantine/core';

import styles from './Skeleton.module.scss';

interface SkeletonGridProps {
  rows?: number;
  columns?: number;
  height?: number;
  gap?: string;
}

const SkeletonGrid: React.FC<SkeletonGridProps> = ({
  rows = 1,
  columns = 1,
  height = 20,
  gap = '10px'
}) => {
  const totalCells = rows * columns;

  const skeletonCells = Array.from({ length: totalCells }, (_, index) => (
    <Skeleton height={height} key={index} />
  ));

  return (
    <div
      className={styles.skeletonGrid}
      style={{
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap
      }}>
      {skeletonCells}
    </div>
  );
};

export default SkeletonGrid;
